import type { ComponentType } from 'react';
import { VueJalonsTaches } from './vue-jalons-taches/VueJalonsTaches';
import { RolesProposal } from './roles-projet/RolesProposal';
import { CollaboratorsProposal } from './collaborateurs-tache/CollaboratorsProposal';
import { DocumentsProposal } from './documents/DocumentsProposal';
import { ImplicationsProposal } from './implications/ImplicationsProposal';
import { TimelineProposal } from './timeline-taches/TimelineProposal';

// Registry of the proposals shown on the "Proposition nouvelle vue
// jalons/tâches" page. Each proposal lives in its own folder under
// src/client/proposals/<id>/ (server side: src/server/proposals/) and is
// listed here once — withdrawing one means deleting its folders and its entry
// below. Commits touching a proposal are prefixed "[Proposition: <id>]" so any
// change it made to shared code can be found and reverted together.
export interface Proposal {
  /** Folder name and stable id, e.g. 'vue-jalons-taches'. */
  id: string;
  /** i18n key of the short title shown as the tab label. */
  titleKey: string;
  /** i18n key of one or two sentences: the problem and what the proposal changes. */
  summaryKey: string;
  /** The proposal's own UI (prototype view, mock-up…). */
  Component: ComponentType;
}

export const PROPOSALS: Proposal[] = [
  {
    id: 'vue-jalons-taches',
    titleKey: 'vjt.title',
    summaryKey: 'vjt.summary',
    Component: VueJalonsTaches,
  },
  {
    id: 'roles-projet',
    titleKey: 'roles.title',
    summaryKey: 'roles.summary',
    Component: RolesProposal,
  },
  {
    id: 'collaborateurs-tache',
    titleKey: 'collab.title',
    summaryKey: 'collab.summary',
    Component: CollaboratorsProposal,
  },
  {
    id: 'documents',
    titleKey: 'docs.prop.title',
    summaryKey: 'docs.prop.summary',
    Component: DocumentsProposal,
  },
  {
    id: 'implications',
    titleKey: 'impl.title',
    summaryKey: 'impl.summary',
    Component: ImplicationsProposal,
  },
  {
    id: 'timeline-taches',
    titleKey: 'tlt.title',
    summaryKey: 'tlt.summary',
    Component: TimelineProposal,
  },
];
